<template>
  <v-layout row justify-center>
    <v-btn  fab 
      dark
      x-large
      @click.stop="dialog = true"
    >
     <img src="home_iconos_dibujos.png" width="80px" style="margin-top:-10%"/>
      <!--<v-img src="home_iconos_dibujos.png"></v-img> -->
    </v-btn>

    <v-dialog
      v-model="dialog"
      max-width="1000"
    >
      <v-card>
          <v-card-actions>
          <v-spacer></v-spacer>
        <v-btn fab dark color="#2f478d"  @click="dialog = false">
        <p style="font-family:Fredoka one; font-size:2vw">X</p>
        <!--<v-icon dark x-large>close</v-icon>-->
    </v-btn>
        </v-card-actions>

        <v-card-title class="headline" ></v-card-title>
            <div align="center" style="margin-top:-8%">
            <v-img src="pop-up_0001_popup.png" width="900px"></v-img> </div>
        <v-card-text>
          
        </v-card-text>

      </v-card>
    </v-dialog>
  </v-layout>
</template>


<script>
  export default {
    data () {
      return {
        dialog: false
      }
    }
  }
</script>